import * as model from './model.js';
import searchView from './view/searchView.js';
import resultsView from './view/resultsView.js';

const controlSearchResults = async function () {
  try {
  
    // 1)Get search query
    const query = searchView.getQuery();
    if (!query) return;

    // 2)Load search results
    await model.loadSearchResults(query);

    // 3)Render results
    resultsView.render(model.state.search.sum);
     console.log(model.state.search.sum)
    // resultsView.render(model.getSearchResultsPage());

   
  } catch (err) {
    console.error(err);
  }
};


const init = function(){
  searchView.addHandlerSearch(controlSearchResults);
}

init()